import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmployerDto } from 'src/app/api/exa';
import { EmployerService } from 'src/app/services/employer.service';
import { EmployerAddDialogComponent } from '../employer-add-dialog/employer-add-dialog.component';
import { EmployerSelectDialogComponent } from '../employer-select-dialog/employer-select-dialog.component';
import { RequestTestAccountDialogComponent } from '../request-test-account-dialog/request-test-account-dialog.component';

@Component({
  selector: 'app-employer-select',
  templateUrl: './employer-select.component.html',
  styleUrls: ['./employer-select.component.scss'],
})
export class EmployerSelectComponent implements OnInit, OnDestroy {
  selected: EmployerDto = null;
  noEmployers = false;

  private terminate$: Subject<void> = new Subject();
  constructor(
    private log: NGXLogger,
    private employerService: EmployerService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    this.employerService
      .onSelectEmployer()
      .pipe(takeUntil(this.terminate$))
      .subscribe(
        (ret) => {
          this.selected = ret;
        },
        (err) => {
          this.selected = null;
        }
      );
    this.employerService
      .onGetEmployers()
      .pipe(takeUntil(this.terminate$))
      .subscribe(
        (ret) => {
          this.noEmployers = ret.length === 0;
        },
        (err) => {
          this.noEmployers = false;
        }
      );
  }
  ngOnDestroy(): void {
    this.terminate$.next();
    this.terminate$.complete();
  }

  ionViewDidEnter() {
    this.onClickSelect();
  }
  async onClickSelect() {
    // this.log.debug('Select Betrieb');
    const modal = await this.modalController.create({
      component: EmployerSelectDialogComponent,
      cssClass: 'custom-dialog',
    });
    await modal.present();
    // if interessted on data!
    // const data = await modal.onWillDismiss();
    // this.log.debug('selection:', data);
  }
  async onClickAddEnterprise() {
    const modal = await this.modalController.create({
      component: EmployerAddDialogComponent,
      cssClass: 'custom-dialog h-300',
    });
    await modal.present();
  }
  async onClickRequestTestAccount() {
    const modal = await this.modalController.create({
      component: RequestTestAccountDialogComponent,
      cssClass: ' ',
    });
    const ret = await modal.present();
  }
}
